import {useContext, useEffect, useState} from 'react'
import Button from '../Button'
import LeadClientInput from '../LeadClientInput'
import SelectInput from '../SelectInput'
import { portalFilterOptions } from '../../data/portalFormListData'
import CloseCross from '../CloseCross'
import filtersIcon from '../../assets/icons/filter-light.svg'
import closeCrossWhite from '../../assets/icons/close-cross-white.svg'



const PortalDealListFilters = ({onDidSelectMember, onDidChangeFilter}) => {

    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        console.log('Deal list filter effect has run')
    }, [onDidSelectMember, onDidChangeFilter])

    const updateSelectedClientLead = (newLead) => {
        onDidSelectMember(newLead)
    }

    const updatedMainFilter = (newFilter) => {
        onDidChangeFilter(newFilter)
    }

    const performReset = () => {
        
    }

    const toggleFilters = () => {
        setIsVisible(!isVisible)
    }

    return (
        <>
            <div className='portal--filter'>
            <div className='portal--filter_toggle'>
            {isVisible && 
                <button className='' onClick={toggleFilters}>
                    <img src={closeCrossWhite} alt='' />
                </button> 
            }
            {!isVisible &&
                <button className='' onClick={toggleFilters}>
                    <img src={filtersIcon} alt='' />
                </button> 
            }
            </div>
                        
            {isVisible && 
            <>
            <div className='portal--filter-row'>
                <label>Search by client/lead:</label>
            <LeadClientInput
                    value={(fromValue) => updateSelectedClientLead(fromValue)}
                    required={false}
                    label='Lead/Client'
                    skeleton={false} 
                    showReset={true}
                />
            </div>
            <div className='portal--filter-row'>
                <label>Filter deals: </label>
                <SelectInput 
                    options={portalFilterOptions}
                    value={(newValue) => updatedMainFilter(newValue)}
                />
            </div>
            </>
            }

            </div>
        </>
    )
}

export default PortalDealListFilters